import React, {PropTypes} from 'react';
import {reduxForm} from 'redux-form';
import validateTool from 'validate.js';
import config from 'config';
import Input from '../../form/Input';
import ImageUpload from '../../form/ImageUpload';
import Participant from '../../../api/participant';
import emptyFunction from  'fbjs/lib/emptyFunction';
import { Container } from 'react-grid-system';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import IconButton from 'material-ui/IconButton';
import IconClose from '../../Icons/IconClose';
import RaisedButton  from 'material-ui/RaisedButton';

const validate = (data) => {
  let {name} = Participant.validateConstraints;

  return validateTool(data, {
      name
    }) || {};
};


class ParticipantsEditForm extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    save: PropTypes.func.isRequired
  };

  async save(data) {
    try {
      await this.props.save(Object.assign(this.props.model, data));
      await this.onSuccessAdd();
    }
    catch (error) {
      /* eslint no-console: 0 */
      console.error(error);
    }
  }

  async processSubmit() {
    await this.props.handleSubmit(data => this.save(data))(this.props.values);
  }

  async onSuccessAdd() {
    let {onAdd, model} = this.props;
    await onAdd(model);
    return await this.onClose();
  }

  onClose() {
    let {onClose, goIndex} = this.props;
    if (onClose) {
      onClose();
    }

    if (goIndex) {
      goIndex();
    }
  }

  imageOnLoad = () => {
    window.dispatchEvent(new Event('resize'));
  }

  _renderHeader() {
    let {title} = this.props;

    return (
      <LoggedAppBar
        isStatic={true}
        title={title}
        iconElementRight={
          <IconButton onClick={() => this.onClose()}><IconClose /></IconButton>
        }
      />
    );
  }

  render() {
    let {
      fields: {name, logo},
      submitting
    } = this.props;

    return (
      <Container style={{margin: 0, padding: 30}}>
        <form onSubmit={() => this.processSubmit()}>
          {this._renderHeader()}
            <ImageUpload
              label='Upload image'
              format='image/png'
              required
              crop={config.participantCrop}
              imageOnLoad={this.imageOnLoad}
              {...logo}
            />
            <Input label='Name' required {...name}/>
            <div style={{textAlign: 'center'}}>
              <RaisedButton label={'Save'} primary={true} disabled={submitting} onClick={() => this.processSubmit()}/>
            </div>
        </form>
      </Container>
    );
  }
}

ParticipantsEditForm.defaultProps = {
  onAdd: emptyFunction,
  onClose: emptyFunction
};

export default reduxForm(
  {
    form: 'participants_edit_form',
    fields: ['name', 'logo'],
    returnRejectedSubmitPromise: true,
    validate,
    asyncBlurFields: ['logo'],
    asyncValidate: async(data) => {
      await validateTool.async(data, {
        logo: {
          presence: {message: '^Please upload an image'},
          minImageSizeAsync: config.participantCrop
        }
      });

      return {};
    }
  }
)(ParticipantsEditForm);



// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsEditForm/ParticipantsEditForm.jsx